import { QrCode, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const QRCodePage = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/reva-menu-qr-code.png';
    link.download = 'reva-dining-menu-qr-code.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen pt-28 pb-16 bg-gradient-to-b from-silver-bright to-white" data-testid="qr-code-page">
      <div className="container-elegant max-w-2xl">
        <div className="text-center mb-8">
          <h1 className="font-serif text-3xl md:text-4xl text-gray-800 mb-2">Menu QR Code</h1>
          <p className="text-gray-500">Scan to view our digital menu</p>
        </div>

        <div className="card-elegant p-8 text-center">
          <div className="bg-white p-6 rounded-xl shadow-sm inline-block mb-6">
            <img 
              src="/reva-menu-qr-code.png" 
              alt="Reva Dining Menu QR Code"
              className="w-64 h-64 md:w-80 md:h-80"
            />
          </div>

          <div className="space-y-4">
            <p className="text-gray-600">
              This QR code links to:<br />
              <span className="text-malva-dark font-medium">https://revadining.co.uk/menu-qr</span>
            </p>

            <Button onClick={handleDownload} className="btn-primary">
              <Download className="w-4 h-4 mr-2" />
              Download QR Code
            </Button>

            <p className="text-gray-400 text-sm mt-4">
              Perfect for table stands, menus, posters, and marketing materials
            </p>
          </div>
        </div>

        <div className="mt-8 card-elegant p-6">
          <h3 className="font-serif text-lg text-gray-800 mb-4">QR Code Specifications</h3>
          <ul className="space-y-2 text-gray-600 text-sm">
            <li>• Resolution: 1230 x 1230 pixels (high quality)</li>
            <li>• Format: PNG</li>
            <li>• Colors: Dark malva on white (high contrast)</li>
            <li>• Error correction: High (reliable scanning)</li>
            <li>• Suitable for both digital and print use</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default QRCodePage;
